import { render, staticRenderFns } from "./PsiDetailSubscriptions.vue?vue&type=template&id=acdfced2&scoped=true"
import script from "./PsiDetailSubscriptions.vue?vue&type=script&lang=js"
export * from "./PsiDetailSubscriptions.vue?vue&type=script&lang=js"
import style0 from "./PsiDetailSubscriptions.vue?vue&type=style&index=0&id=acdfced2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acdfced2",
  null
  
)

export default component.exports